(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shark-drop-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shark-drop-countdown')) {
    customElements.define('shark-drop-countdown', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.refresh = () => {
          clearInterval(this.timer);
          this.timer = undefined;
          if (this.tick() && !document.hidden) this.timer = setInterval(() => this.tick(), 1000);
        };
        document.addEventListener('visibilitychange', this.refresh, { signal: this.controller.signal });
        this.refresh();
      }
      disconnectedCallback() { clearInterval(this.timer); this.timer = undefined; this.controller?.abort(); }
      parseDate(value) {
        const match = /^(\d{4})-(\d{2})-(\d{2})T([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?(?:Z|[+-](?:0\d|1[0-4]):[0-5]\d)$/.exec(value || '');
        if (!match) return NaN;
        const [, year, month, day] = match.map(Number);
        const check = new Date(Date.UTC(year, month - 1, day));
        if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return NaN;
        return Date.parse(value);
      }
      write(selector, value) {
        this.querySelectorAll(selector).forEach(node => { if (node.textContent !== value) node.textContent = value; });
      }
      tick() {
        const now = Date.now();
        let end = this.parseDate(this.dataset.end);
        let start = this.dataset.start ? this.parseDate(this.dataset.start) : 0;
        if (!Number.isFinite(start)) start = 0;
        let calendar = this.dataset.calendar || '';
        let label = null;
        const primaryValid = Number.isFinite(end) && Number.isFinite(start) && start < end;
        if (this.dataset.altEnd && (!primaryValid || now >= end)) {
          const alt = this.parseDate(this.dataset.altEnd);
          if (Number.isFinite(alt) && (now < alt || alt > end || !primaryValid)) {
            end = alt;
            start = Number.isFinite(start) && start < alt ? start : 0;
            calendar = this.dataset.altCalendar || calendar;
            label = this.dataset.altLabel || null;
          }
        }
        const valid = Number.isFinite(end) && Number.isFinite(start) && start < end;
        this.hidden = !valid;
        if (!valid) { clearInterval(this.timer); this.timer = undefined; return false; }
        if (label) this.write('[data-cd-label]', label);
        if (this.dataset.activeCalendar !== calendar) this.dataset.activeCalendar = calendar;
        const state = now >= end ? 'ended' : now < start ? 'upcoming' : 'active';
        if (this.dataset.state !== state) this.dataset.state = state;
        const closed = this.querySelector('[data-cd-closed]');
        if (closed) closed.hidden = state !== 'ended';
        const upcoming = this.querySelector('[data-cd-upcoming]');
        if (upcoming) upcoming.hidden = state !== 'upcoming';
        const seconds = state === 'ended' ? 0 : Math.max(0, Math.ceil(((state === 'upcoming' ? start : end) - now) / 1000));
        const days = Math.floor(seconds / 86400);
        const pad = number => String(number).padStart(2, '0');
        const hours = pad(Math.floor(seconds / 3600) % 24);
        const minutes = pad(Math.floor(seconds / 60) % 60);
        const rest = pad(seconds % 60);
        this.write('[data-cd-d]', pad(days));
        this.write('[data-cd-h]', hours);
        this.write('[data-cd-m]', minutes);
        this.write('[data-cd-s]', rest);
        const bare = this.classList.contains('sd-cd--inline');
        const spoken = state === 'ended' ? this.dataset.ended : `${bare ? '' : state === 'upcoming' ? this.dataset.upcoming : this.dataset.active} ${days} ${this.dataset.unitDays || ''}, ${Number(hours)} ${this.dataset.unitHours || ''}, ${Number(minutes)} ${this.dataset.unitMinutes || ''}`.replace(/\s+/g, ' ').trim();
        this.write('[data-cd-a11y]', (label || this.querySelector('[data-cd-label]')?.textContent || '') + (label || this.querySelector('[data-cd-label]') ? ': ' : '') + spoken);
        const compact = this.querySelector('[data-cd-compact]');
        if (compact) {
          const withPrefix = compact.hasAttribute('data-cd-prefix');
          let text;
          if (state === 'ended' && withPrefix) {
            text = this.dataset.ended;
          } else {
            const clock = `${days}${this.dataset.daysShort || 'g'} ${hours}:${minutes}:${rest}`;
            text = withPrefix ? `${state === 'upcoming' ? this.dataset.upcoming : this.dataset.active} ${clock}` : clock;
          }
          if (compact.textContent !== text) compact.textContent = text;
        }
        if (state === 'ended') { clearInterval(this.timer); this.timer = undefined; }
        return state !== 'ended';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shark-drop-singolo-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shark-drop-singolo-countdown')) {
    customElements.define('shark-drop-singolo-countdown', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.refresh = () => {
          clearInterval(this.timer);
          this.timer = undefined;
          if (this.tick() && !document.hidden) this.timer = setInterval(() => this.tick(), 1000);
        };
        document.addEventListener('visibilitychange', this.refresh, { signal: this.controller.signal });
        this.refresh();
      }
      disconnectedCallback() { clearInterval(this.timer); this.timer = undefined; this.controller?.abort(); }
      parseDate(value) {
        const match = /^(\d{4})-(\d{2})-(\d{2})T([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?(?:Z|[+-](?:0\d|1[0-4]):[0-5]\d)$/.exec(value || '');
        if (!match) return NaN;
        const [, year, month, day] = match.map(Number);
        const check = new Date(Date.UTC(year, month - 1, day));
        if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day) return NaN;
        return Date.parse(value);
      }
      write(selector, value) {
        this.querySelectorAll(selector).forEach(node => { if (node.textContent !== value) node.textContent = value; });
      }
      tick() {
        const now = Date.now();
        let end = this.parseDate(this.dataset.end);
        let start = this.dataset.start ? this.parseDate(this.dataset.start) : 0;
        if (!Number.isFinite(start)) start = 0;
        let calendar = this.dataset.calendar || '';
        let label = null;
        const primaryValid = Number.isFinite(end) && Number.isFinite(start) && start < end;
        if (this.dataset.altEnd && (!primaryValid || now >= end)) {
          const alt = this.parseDate(this.dataset.altEnd);
          if (Number.isFinite(alt) && (now < alt || alt > end || !primaryValid)) {
            end = alt;
            start = Number.isFinite(start) && start < alt ? start : 0;
            calendar = this.dataset.altCalendar || calendar;
            label = this.dataset.altLabel || null;
          }
        }
        const valid = Number.isFinite(end) && Number.isFinite(start) && start < end;
        this.hidden = !valid;
        if (!valid) { clearInterval(this.timer); this.timer = undefined; return false; }
        if (label) this.write('[data-cd-label]', label);
        if (this.dataset.activeCalendar !== calendar) this.dataset.activeCalendar = calendar;
        const state = now >= end ? 'ended' : now < start ? 'upcoming' : 'active';
        if (this.dataset.state !== state) this.dataset.state = state;
        const closed = this.querySelector('[data-cd-closed]');
        if (closed) closed.hidden = state !== 'ended';
        const upcoming = this.querySelector('[data-cd-upcoming]');
        if (upcoming) upcoming.hidden = state !== 'upcoming';
        const seconds = state === 'ended' ? 0 : Math.max(0, Math.ceil(((state === 'upcoming' ? start : end) - now) / 1000));
        const days = Math.floor(seconds / 86400);
        const pad = number => String(number).padStart(2, '0');
        const hours = pad(Math.floor(seconds / 3600) % 24);
        const minutes = pad(Math.floor(seconds / 60) % 60);
        const rest = pad(seconds % 60);
        this.write('[data-cd-d]', pad(days));
        this.write('[data-cd-h]', hours);
        this.write('[data-cd-m]', minutes);
        this.write('[data-cd-s]', rest);
        const bare = this.classList.contains('sds-cd--inline');
        const spoken = state === 'ended' ? this.dataset.ended : `${bare ? '' : state === 'upcoming' ? this.dataset.upcoming : this.dataset.active} ${days} ${this.dataset.unitDays || ''}, ${Number(hours)} ${this.dataset.unitHours || ''}, ${Number(minutes)} ${this.dataset.unitMinutes || ''}`.replace(/\s+/g, ' ').trim();
        this.write('[data-cd-a11y]', (label || this.querySelector('[data-cd-label]')?.textContent || '') + (label || this.querySelector('[data-cd-label]') ? ': ' : '') + spoken);
        const compact = this.querySelector('[data-cd-compact]');
        if (compact) {
          const withPrefix = compact.hasAttribute('data-cd-prefix');
          let text;
          if (state === 'ended' && withPrefix) {
            text = this.dataset.ended;
          } else {
            const clock = `${days}${this.dataset.daysShort || 'g'} ${hours}:${minutes}:${rest}`;
            text = withPrefix ? `${state === 'upcoming' ? this.dataset.upcoming : this.dataset.active} ${clock}` : clock;
          }
          if (compact.textContent !== text) compact.textContent = text;
        }
        if (state === 'ended') { clearInterval(this.timer); this.timer = undefined; }
        return state !== 'ended';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
